import React from "react";
import Box from "@mui/material/Box";
import OperationalReports from "../orders/reports/OperationalReports";

export default function ReportIndex(props) {
  return (
    <Box sx={{ px: 5, pt: 5, pb: 10 }}>
      <OperationalReports />
    </Box>
  );
}
